import LayoutSecundario from '../../layout/LayoutSecundario/LayoutSecundario'
import Calendar from '../../components/Calendar/Calendar'

const Lanzamientos = () => {
  return (
    <LayoutSecundario textoBoton={'lanzamientos'}>
        <Calendar />
    </LayoutSecundario>
  )
}

export default Lanzamientos;